import React from 'react';
import ReactDOM from 'react-dom/client';
/* Vendor CSS, bundled from node_modules instead of a CDN. Order matters:
   these load before our own sheets so index.css / style.css still win. */
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'slick-carousel/slick/slick.css';
/* Self-hosted brand fonts (bundled locally via @fontsource - no CDN, CSP-safe) */
import '@fontsource/rajdhani/400.css';
import '@fontsource/rajdhani/500.css';
import '@fontsource/rajdhani/600.css';
import '@fontsource/rajdhani/700.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './index.css';
import './assets/css/style.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './redux/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <Provider store={store} >
    <App />
    </Provider>
  // </React.StrictMode>
);

reportWebVitals();
